/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import Button from "@material-ui/core/Button";

import React from "react";
import { FormattedMessage } from "react-intl";

import useNotification from "common/hooks/useNotification";
import { ExtendedFetchBaseQueryError } from "common/types/ExtendedFetchBaseQueryError";

import ErrorMessage from "application/components/ErrorMessage/ErrorMessage";
import NotificationDialog from "application/components/NotificationDialog/NotificationDialog";
import { useCommonState } from "common/hooks";
import { getAnalyticsInfo } from "common/util";

export default function Notification() {
    const { dequeueNotification } = useNotification();
    const { notification } = useCommonState();

    if (!notification.length) return <></>;

    const analyticsInfo = getAnalyticsInfo(notification[0]);

    return (
        <NotificationDialog
            open={notification.length !== 0}
            analyticsInfo={analyticsInfo}
            actions={
                <Button
                    fullWidth
                    color="primary"
                    onClick={() => {
                        dequeueNotification();
                    }}
                >
                    <FormattedMessage defaultMessage="Close" id="common.error.close" />
                </Button>
            }
        >
            {notification[0] && (
                <>
                    {notification[0]!.error && (
                        <ErrorMessage
                            error={notification[0].error as Error | ExtendedFetchBaseQueryError}
                            message={notification[0].message}
                        />
                    )}
                </>
            )}
        </NotificationDialog>
    );
}
